export default __webpack_public_path__ + "static/media/O-033.ac3faeab.png";